
const Main = () => import('@/views/main');
const financialIndex = () => import('@/views/financial/index');
const financialDetail = () => import('@/views/financial/detail');
const operationRecord = () => import('@/views/financial/operation-record');
const paymentAndVerifyReport = () => import('@/views/financial/payment-and-verify-report');

export default [{
    path: '/financial',
    name: 'financial',
    redirect: '/financialIndex',
    component: Main,
    meta: {
        hide: false,
        name: '财务管理',
        unfold: true,
        iconType: '14'
    },
    children: [
        {
            path: '/financialIndex',
            name: 'financialIndex',
            component: financialIndex,
            meta: {
                name: '财务管理'
            },
            children: [
                {
                    path: '/financialDetail',
                    name: 'financialDetail',
                    component: financialDetail,
                    meta: {
                        name: '明细'
                    },
                },
                {
                    path: '/operationRecord',
                    name: 'operationRecord',
                    component: operationRecord,
                    meta: {
                        name: '操作记录'
                    },
                },
            ]
        },
        {
            path: '/paymentAndVerifyReport',
            name: 'paymentAndVerifyReport',
            component: paymentAndVerifyReport,
            meta: {
                name: '收付核销报表',
                hide: false,
                unfold: false,
                auth: true
            }
        },
    ]
}]

